export default class popupProductsApi {

    constructor() {
        this.container = document.querySelectorAll('.popup-products-api-cont');
        this.slider = document.querySelectorAll('.product-line-slider');
        this.popupproductsapi = document.querySelectorAll('.popup-products-api-new');
        this.closePopup = document.querySelector('.close-popup');
        this.popup = document.querySelector('.popup-products-api__window');
        this.body = document.querySelector('body');
        this.html = document.querySelector('html');
        this.mobilesticky = document.querySelector('.mobile-menu-sticky');
        this.morebuttext = document.getElementById('more-but-text');

        //Open popup from attry thumbnail
        this.story = document.querySelectorAll('.story_thumb_nolightbox');
        if (this.story.length === 0) {
        } else {
            for (let i = 0; i < this.story.length; i++) {
                const openPopup = this.story[i];
                const apiurl = this.story[i].querySelector('.prod_api_url');

                openPopup.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.displayPopup();

                    if(apiurl.value) {
                        fetch(apiurl.value)
                            .then(response => response.json())
                            .then(data => {
                                    $('.prod_content h3').empty().append(data.name );
                                    $('.prod_content p').empty().append(data.description);

                                    $('.popup-products-api__window__featured img').attr('src' , data.image_url);
                                    var currency =  data.country.currency !== undefined ? data.country.currency : "€";
                                    var products = "";
                                    for (let i = 0; i < data.products.length; i++) {
                                        var imageUrl = data.products[i].shop.image_url;
                                        var specialPrice = data.products[i].special_price ? data.products[i].special_price : null;
                                        var price = data.products[i].price ? data.products[i].price : null;
                                        var priceOne = specialPrice ? '<span>'+price+' €</span>' : '';
                                        var priceTwo = specialPrice ? specialPrice : price;
                                        products += '<div class="popup-products-api__window__prodbox"><div class="popup-products-api__window__column"><img src="'+imageUrl+'"></div><div class="price popup-products-api__window__column get-calc">'+priceOne+' '+priceTwo+' '+currency+'</div><div class="popup-products-api__window__column online-store_'+data.products[i].shop.label+'"><a onclick="plausible(\'online-store_'+data.products[i].shop.label+'\')" class="btn btn-primary" target="_blank" href="'+data.products[i].url+'">'+this.morebuttext.innerText+'</a></div></div>';
                                    }
                                    $('#popup-prod-data').empty().append(products);
                                }
                            );
                    }

                });
            }
        }

        // Is the element present on the current page
        if (this.container.length === 0) {
            return;
        } else {
            for (let i = 0; i < this.container.length; i++) {
                const openPopup = this.container[i].querySelector('.api-popup-open');
                const apiurl = this.container[i].querySelector('.prod_api_url');

                //Open popup by hash #open
                const hash = window.location.hash;

                if (hash.includes('open') && hash.includes(apiurl.getAttribute('data-id'))) {
                    this.displayPopup();
                    const urlhash =  hash.replace("#open", "").replace("#", "");
                    const apiurlGet = document.querySelector('[data-id="'+urlhash+'"]');
                    console.log(apiurlGet);
                    if(apiurlGet.value) {
                        fetch(apiurlGet.value)
                            .then(response => response.json())
                            .then(data => {
                                    $('.prod_content h3').empty().append(data.name );
                                    $('.prod_content p').empty().append(data.description);

                                    $('.popup-products-api__window__featured img').attr('src' , data.image_url);
                                    var currency =  data.country.currency !== undefined ? data.country.currency : "€";
                                    var products = "";
                                    for (let i = 0; i < data.products.length; i++) {
                                        var imageUrl = data.products[i].shop.image_url;
                                        var specialPrice = data.products[i].special_price ? data.products[i].special_price : null;
                                        var price = data.products[i].price ? data.products[i].price : null;
                                        var priceOne = specialPrice ? '<span>'+price+' '+currency+'</span>' : '';
                                        var priceTwo = specialPrice ? specialPrice : price;
                                        products += '<div class="popup-products-api__window__prodbox"><div class="popup-products-api__window__column"><img src="'+imageUrl+'"></div><div class="price popup-products-api__window__column get-calc">'+priceOne+' '+priceTwo+' '+currency+'</div><div class="popup-products-api__window__column online-store_'+data.products[i].shop.label+'"><a onclick="plausible(\'online-store_'+data.products[i].shop.label+'\')" class="btn btn-primary" target="_blank" href="'+data.products[i].url+'">'+this.morebuttext.innerText+'</a></div></div>';
                                    }
                                    $('#popup-prod-data').empty().append(products);
                                }
                            );
                    }
                }


                openPopup.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.displayPopup();

                    if(apiurl.value) {
                        fetch(apiurl.value)
                            .then(response => response.json())
                            .then(data => {
                                   $('.prod_content h3').empty().append(data.name );
                                     $('.prod_content p').empty().append(data.description);

                                     $('.popup-products-api__window__featured img').attr('src' , data.image_url);
                                     var currency =  data.country.currency !== undefined ? data.country.currency : "€";
                                     var products = "";
                                     for (let i = 0; i < data.products.length; i++) {
                                        var imageUrl = data.products[i].shop.image_url;
                                        var specialPrice = data.products[i].special_price ? data.products[i].special_price : null;
                                        var price = data.products[i].price ? data.products[i].price : null;
                                        var priceOne = specialPrice ? '<span>'+price+' €</span>' : '';
                                        var priceTwo = specialPrice ? specialPrice : price;
                                        products += '<div class="popup-products-api__window__prodbox"><div class="popup-products-api__window__column"><img src="'+imageUrl+'"></div><div class="price popup-products-api__window__column get-calc">'+priceOne+' '+priceTwo+' '+currency+'</div><div class="popup-products-api__window__column online-store_'+data.products[i].shop.label+'"><a onclick="plausible(\'online-store_'+data.products[i].shop.label+'\')" class="btn btn-primary" target="_blank" href="'+data.products[i].url+'">'+this.morebuttext.innerText+'</a></div></div>';
                                     }
                                     $('#popup-prod-data').empty().append(products);
                                }
                            );
                    }

                });
            }

            this.closePopup.addEventListener('click', (e) => {
                e.preventDefault();
                this.hidePopup();
            });

            //Close popup
            this.popup.addEventListener('click', (e) => {
                if (!e.target.closest('.container')) {
                    this.hidePopup();
                }
            });

        }

    }

    displayPopup() {
        this.popup.style.display = "flex";
        this.body.style.overflow = "hidden";
        this.html.style.overflow = "hidden";
        this.mobilesticky.classList.remove('visible');
    }
    hidePopup() {
        this.popup.style.display = "none";
        this.body.style.overflow = "";
        this.html.style.overflow = "";
    }
}
